import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatDetail } from "@/lib/api";

export default function LoginPage() {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(u.trim(), p);
      toast.success(`Welcome, ${user.full_name}`);
      if (user.role === "staff") nav("/staff");
      // zen123 is the dedicated mobile-monitor account — skip the heavy
      // /admin dashboard and land directly on the phone-friendly bookings list.
      else if (user.username === "zen123") nav("/mobile-bookings");
      else nav("/admin");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zen-bg flex items-center justify-center px-6">
      <div className="max-w-sm w-full" data-testid="login-card">
        <div className="text-xs tracking-[0.25em] uppercase text-zen-muted mb-4">— Staff & Owner</div>
        <h1 className="font-serif text-5xl text-zen-ink leading-none mb-2">Welcome back</h1>
        <p className="text-zen-muted mb-10">Sign in to manage Zen Nails Lounge & Spa.</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-[0.15em] text-zen-muted mb-2 block">Username</Label>
            <Input value={u} onChange={(e) => setU(e.target.value)} placeholder="username"
              className="bg-zen-surface border-0 h-12 rounded-lg" autoFocus
              data-testid="login-username-input" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.15em] text-zen-muted mb-2 block">Password</Label>
            <Input type="password" value={p} onChange={(e) => setP(e.target.value)}
              className="bg-zen-surface border-0 h-12 rounded-lg"
              data-testid="login-password-input" />
          </div>
          <Button type="submit" disabled={busy}
            className="w-full rounded-full bg-zen-primary hover:bg-zen-primary-hover text-white h-12 mt-4"
            data-testid="login-submit-btn">
            {busy ? "Signing in…" : "Sign In"}
          </Button>
        </form>
        <a href="/" className="block text-sm text-zen-muted mt-8 hover:text-zen-ink" data-testid="back-to-booking">
          ← Back to booking
        </a>
      </div>
    </div>
  );
}
